<template>
  <div>
    <DxNumberBox
      :value="value"
      :format="getDecimalFormatFromHelper(format)"
      :disabled="true"
      v-bind:style="{
        width: (Math.round(value).toString().length + length) * 8 + 'px',
      }"
    />
  </div>
</template>

<script>
import { getDecimalFormat } from "@/_store/helpers";
export default {
  props: ["value", "format", "length"],

  mixins: [],
  created() {},
  methods: {
    getDecimalFormatFromHelper(format) {
      return getDecimalFormat(format).ReadOnlyFormat;
    },
  },
};
</script>
